import "./Stones.css";

import stone1 from "../images/projects/taslar/taslar1.jpeg";
import stone2 from "../images/projects/taslar/taslar2.jpeg";
import stone3 from "../images/projects/taslar/taslar3.jpeg";
import stone4 from "../images/projects/taslar/taslar4.jpeg";
import stone5 from "../images/projects/taslar/taslar5.jpeg";
import stone6 from "../images/projects/taslar/taslar6.jpeg";
import stone7 from "../images/projects/taslar/taslar7.jpeg";
import stone8 from "../images/projects/taslar/taslar8.jpeg";
import stone9 from "../images/projects/taslar/taslar9.jpeg";
import stone10 from "../images/projects/taslar/taslar10.jpeg";
import stone11 from "../images/projects/taslar/taslar11.jpeg";
import stone12 from "../images/projects/taslar/taslar12.jpeg";
import stone13 from "../images/projects/taslar/taslar13.jpeg";
import stone14 from "../images/projects/taslar/taslar14.jpeg";
import stone15 from "../images/projects/taslar/taslar15.jpeg";
import stone16 from "../images/projects/taslar/taslar16.jpeg";
import stone17 from "../images/projects/taslar/taslar17.jpeg";
import stone18 from "../images/projects/taslar/taslar19.jpeg";
import stone19 from "../images/projects/taslar/taslar20.jpeg";
import stone20 from "../images/projects/taslar/taslar21.jpeg";
import stone21 from "../images/projects/taslar/taslar22.jpeg";
import stone22 from "../images/projects/taslar/taslar23.jpeg";
import stone23 from "../images/projects/taslar/taslar24.jpeg";




export default function Stones() {

  const stones = [

    {
      image: stone1,
      title: "CALACATTA GOLD"
    },

    {
      image: stone2,
      title: "CARRARA WHITE"
    },

    {
      image: stone3,
      title: "BLACK GALAXY"
    },

    {
      image: stone4,
      title: "ABSOLUTE BLACK"
    },

    {
      image: stone5,
      title: "BLUE PEARL"
    },

    {
      image: stone6,
      title: "STATUARIO"
    },
     {
      image: stone7,
      title:"TOROS SİYAH"
    },
       {
      image: stone8,
      title: "EMPERADOR DARK"
    },

       {
      image: stone9,
      title: "ONYX WHITE"
    },
       {
      image: stone10,
      title:"NERO ZIMBABWE"
    },
       {
      image: stone11,
      title: "STEEL GREY"
    },
       {
      image: stone12,
      title: "ROSSO LEVANTO"
    },
       {
      image: stone13,
      title: "SILVER TRAVERTEN"
    },
       {
      image: stone14,
      title: "TAJ MAHAL QUARTZITE"
    },
       {
      image: stone15,
      title: "COLONIAL WHITE"
    },
       {
      image: stone16,
      title: "LABRADOR ANTIQUE"
    },
       {
      image: stone17,
      title: "BLACK MARQUINA"
    },
       {
      image: stone18,
      title: "VISCON WHITE"
    },
     {
      image: stone19,
      title: "MUĞLA BEYAZ"
    },

     {
      image: stone20,
      title: "AFYON ŞEKER"
    },

     {
      image: stone21,
      title: "MARMARA WHITE"
    },

     {
      image: stone22,
      title:"BEJ MERMER"
    },

     {
      image: stone23,
      title: "TRAVERTEN"
    },



  ];

  return (

    <section className="stones-page">

      <div className="stones-header">

        <h1>Mermer ve Granit Çeşitleri</h1>

      </div>

      <div className="stones-grid">

        {stones.map((stone, index) => (

          <div className="stone-card" key={index}>

            <img src={stone.image} alt="" />

            <h3>{stone.title}</h3>

          </div>

        ))}

      </div>

    </section>
  );
}